import { Identifier } from "../../id";
export class PackagingContainerTypeId extends Identifier {
    constructor(id) {
        super("PackagingContainerTypeId", id);
    }
}
